import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroupCacheKeys: AllRouteEndpoints[] = [
  "/internal_user_groups/:internal_user_group_id/test_users_v2",
];
